/* Everhart theme behavior (Shopify port).
   The old localStorage cart is gone: Shopify owns cart state; the header
   icon links to /cart. Only presentation behaviors live here. */
(function () {
  "use strict";
  var navToggle = document.querySelector(".nav-toggle");
  var mobileNav = document.querySelector(".mobile-nav");
  if (navToggle && mobileNav) {
    navToggle.addEventListener("click", function () {
      var open = mobileNav.classList.toggle("open");
      navToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
  }
})();

/* Gentle fade-up as sections enter the screen (once). Skipped when the
   visitor has asked their device for reduced motion. */
(function () {
  "use strict";
  if (!("IntersectionObserver" in window)) return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  var targets = document.querySelectorAll("main > section:not(.cel-hero), main > .trust-strip, main > article");
  if (!targets.length) return;
  var vh = window.innerHeight || 800;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); }
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
  targets.forEach(function (el) {
    if (el.getBoundingClientRect().top < vh * 0.9) return; // already on screen: leave it alone
    el.classList.add("reveal");
    io.observe(el);
  });
})();

/* Turntable videos: hold still for visitors who prefer reduced motion. */
(function () {
  if (!(window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches)) return;
  document.querySelectorAll("video.turn").forEach(function (v) { v.removeAttribute("autoplay"); v.pause(); });
})();

/* Hero: the band tilts once, alongside the "jewelry." push, then holds. */
(function () {
  var v = document.querySelector("video.hero-tilt");
  if (!v) return;
  // phones get a 4:3 version (ring higher up, room for the caption) so the frame fills the panel
  if (window.matchMedia && window.matchMedia("(max-width: 799px)").matches && v.dataset.mSrc) {
    v.poster = v.dataset.mPoster; v.dataset.end = v.dataset.mEnd;
    var srcEl = v.querySelector("source"); if (srcEl) srcEl.src = v.dataset.mSrc; v.load();
  }
  var still = function () { v.poster = v.dataset.end; v.removeAttribute("src"); while (v.firstChild) v.removeChild(v.firstChild); v.load(); };
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) { still(); return; }
  setTimeout(function () {
    var p = v.play();
    if (p && p.catch) p.catch(still);
  }, 1100);
})();

/* Hero: measure "jewelry." so the push animation opens exactly the right space. */
(function () {
  var em = document.querySelector(".cel-title em");
  if (!em) return;
  var span = em.querySelector("span");
  if (span) em.style.setProperty("--jw", Math.ceil(span.getBoundingClientRect().width + em.offsetWidth * 0 + 2) + "px");
})();

/* "What it tracks" photo-card carousel arrows */
(function () {
  var row = document.querySelector(".track-cards");
  if (!row) return;
  document.querySelectorAll(".track-nav button").forEach(function (b) {
    b.addEventListener("click", function () {
      var card = row.querySelector(".track-card");
      var step = card ? card.getBoundingClientRect().width + 16 : 300;
      row.scrollBy({ left: step * Number(b.dataset.dir), behavior: "smooth" });
    });
  });
})();

/* Homepage constellation: rings bloom in and the gold lines draw once it scrolls into view. */
(function () {
  var c = document.querySelector(".constel");
  if (!c || !("IntersectionObserver" in window)) return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  c.classList.add("anim");
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { c.classList.add("is-in"); io.disconnect(); } });
  }, { threshold: 0.35 });
  io.observe(c);
})();

/* Shop the look: add the ticked pieces to the bag in one go. */
(function () {
  document.querySelectorAll(".look-form").forEach(function (f) {
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      var items = [];
      f.querySelectorAll(".look-row").forEach(function (r) {
        var cb = r.querySelector("input[type=checkbox]"); if (!cb || !cb.checked) return;
        var v = r.querySelector("select, input[type=hidden]");
        if (v) { var it = { id: Number(v.value), quantity: 1 }; if (window.EH) it.properties = { Delivery: EH.shipLine(it.id) }; items.push(it); }
      });
      if (!items.length) return;
      var btn = f.querySelector(".look-add") || (f.id && document.querySelector('[form="' + f.id + '"]')); var orig = btn.innerHTML; btn.disabled = true; btn.textContent = "Adding...";
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw r; btn.disabled = false; btn.textContent = "Added"; setTimeout(function () { btn.innerHTML = orig; }, 2500); if (window.EverhartBag) window.EverhartBag.open(); else window.location = "/cart"; })
        .catch(function () { btn.disabled = false; btn.textContent = "Something went wrong, try again"; setTimeout(function () { btn.innerHTML = orig; }, 3000); });
    });
  });
})();

/* Slide-out bag: add to bag without leaving the page. */
(function () {
  var drawer = document.getElementById("cart-drawer"), overlay = document.getElementById("cd-overlay");
  if (!drawer) return;
  var list = document.getElementById("cd-items"), foot = document.getElementById("cd-foot"), total = document.getElementById("cd-total");
  var onCartPage = location.pathname.replace(/\/$/, "") === "/cart";
  function money(c) { var d = c / 100; return "$" + (d % 1 === 0 ? d.toLocaleString("en-US") : d.toLocaleString("en-US", { minimumFractionDigits: 2 })); }
  function esc(t) { var d = document.createElement("div"); d.textContent = t == null ? "" : t; return d.innerHTML; }
  function setCount(n) { document.querySelectorAll(".cart-count").forEach(function (el) { el.textContent = n; el.classList.toggle("show", n > 0); }); }
  function img(item) { var u = item.image || (item.featured_image && item.featured_image.url); return u ? u.replace(/(\.[a-z]+)(\?|$)/i, "$1$2").split("?")[0] + "?width=200" : ""; }
  /* short size for the closed box ("Size 6.5"), full size in the list ("6.5 in (16.5 cm)") */
  function sizeShort(t) { var m = String(t).match(/^([\d.]+)\s*in\b/); if (m) return "Size " + m[1]; return /^[\d.]+$/.test(t) ? "Size " + t : t; }
  function sizeFull(t) { return /^[\d.]+$/.test(t) ? "Size " + t : t; }
  function sizePicker(cls, vars, cur, label) {
    return '<label class="cd-size"><span>' + esc(sizeShort(cur.t)) + '</span><select class="' + cls + '" aria-label="' + label + '">' +
      vars.map(function (v) { return '<option value="' + v.id + '"' + (v.id === cur.id ? " selected" : "") + ">" + esc(sizeFull(v.t)) + "</option>"; }).join("") + "</select></label>";
  }
  window.EHSize = { picker: sizePicker, short: sizeShort };
  function render(cart) {
    setCount(cart.item_count);
    if (!cart.item_count) {
      list.innerHTML = '<p class="cd-empty">Your bag is empty, for now. <a class="lede-link" href="/collections/all">Shop the Collection</a></p>';
      foot.hidden = true; return;
    }
    foot.hidden = false; total.textContent = money(cart.total_price);
    if (window.EHCart) window.EHCart.drawer(cart);
    list.innerHTML = cart.items.map(function (it, i) {
      var pp = it.properties || {}, ship = "";
      if (it.requires_shipping !== false && window.EH) {
        var isStock = pp.Delivery ? /^(In stock|READY)/.test(pp.Delivery) : EH.inStock(it.variant_id), e = EH.etaFor(isStock);
        ship = '<p class="cd-ship' + (isStock ? " is-stock" : "") + '"><strong>' + e.label + "</strong> Arrives " + esc(e.short) + "</p>";
      }
      if (pp.Engraving) ship += '<p class="cd-eng">Engraving: &ldquo;' + esc(pp.Engraving) + '&rdquo; <span>Final sale</span></p>';
      var bv = window.EH && EH.byVariant[it.variant_id], pr = bv && EH.products[bv.h];
      var sizeHTML = it.product_has_only_default_variant ? "" : (pr && pr.v.length > 1 ? '<div class="cd-var">' + sizePicker("cd-size-sel", pr.v, { id: it.variant_id, t: it.variant_title }, "Change size") + "</div>" : '<p class="cd-var">' + esc(sizeShort(it.variant_title)) + "</p>");
      var variant = sizeHTML + ship;
      return '<div class="cd-item" data-line="' + (i + 1) + '" data-key="' + esc(it.key) + '" data-props="' + esc(JSON.stringify(pp)).replace(/"/g, "&quot;") + '">' +
        '<a href="' + it.url + '"><img src="' + img(it) + '" alt="' + esc(it.product_title) + '"></a>' +
        '<div class="cd-body"><a class="cd-name" href="' + it.url + '">' + esc(it.product_title) + "</a>" + variant +
        '<div class="cd-row"><div class="ci-qty"><button type="button" class="qty-btn" data-q="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
        '<span class="cd-q">' + it.quantity + '</span><button type="button" class="qty-btn" data-q="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
        '<span class="cd-price">' + money(it.final_line_price) + "</span></div>" +
        '<button type="button" class="cd-remove" data-q="0">Remove</button></div></div>';
    }).join("");
  }
  function refresh() { return fetch("/cart.js").then(function (r) { return r.json(); }).then(render); }
  function open() { drawer.classList.add("open"); drawer.setAttribute("aria-hidden", "false"); overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add("show"); }); document.body.classList.add("cd-lock"); var c = drawer.querySelector(".cd-close"); if (c) c.focus(); }
  function close() { if (window.EH) EH.hideAddon = false; drawer.classList.remove("open"); drawer.setAttribute("aria-hidden", "true"); overlay.classList.remove("show"); document.body.classList.remove("cd-lock"); setTimeout(function () { overlay.hidden = true; }, 250); }
  window.EverhartBag = { open: function () { refresh().then(open); }, refresh: refresh, render: render };

  overlay.addEventListener("click", close);
  drawer.addEventListener("click", function (e) {
    if (e.target.closest("[data-cd-close]")) return close();
    var b = e.target.closest("[data-q]"); if (!b) return;
    var row = b.closest(".cd-item"); row.classList.add("is-busy");
    fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ line: Number(row.dataset.line), quantity: Number(b.dataset.q) }) })
      .then(function (r) { return r.json(); }).then(render);
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && drawer.classList.contains("open")) close(); });
  /* change size inside the bag: swap the line for the new size, same quantity */
  drawer.addEventListener("change", function (e) {
    var sel = e.target.closest(".cd-size-sel"); if (!sel) return;
    var row = sel.closest(".cd-item"), key = row.dataset.key, id = Number(sel.value), q = Number(row.querySelector(".cd-q").textContent) || 1;
    row.classList.add("is-busy");
    var props = {}; try { props = JSON.parse(row.dataset.props || "{}"); } catch (x) {}
    props.Delivery = window.EH ? EH.shipLine(id) : "";
    // engraving is only offered on made-to-order sizes, so keep it only if the new size is still made to order
    if (window.EH && EH.inStock(id)) { delete props.Engraving; delete props["Final sale"]; }
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: id, quantity: q, properties: props }) })
      .then(function () { return fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: 0 }) }); })
      .then(function (r) { return r.json(); }).then(render);
  });

  if (!onCartPage) {
    document.querySelectorAll('a.icon-btn[href="/cart"]').forEach(function (a) {
      a.addEventListener("click", function (e) { e.preventDefault(); window.EverhartBag.open(); });
    });
  }
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (onCartPage || !f.action || f.action.indexOf("/cart/add") === -1) return;
    e.preventDefault();
    var btn = f.querySelector('[type="submit"]') || document.querySelector('[form="' + f.id + '"][type="submit"]');
    var label = btn ? btn.innerHTML : "";
    if (btn) { btn.disabled = true; btn.textContent = "Adding..."; }
    fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(f) })
      .then(function (r) { if (!r.ok) throw r; return refresh(); })
      .then(function () { open(); if (btn) { btn.disabled = false; btn.innerHTML = label; } })
      .catch(function () { if (btn) { btn.disabled = false; btn.textContent = "Sold out or unavailable"; setTimeout(function () { btn.innerHTML = label; }, 2500); } });
  });
})();

/* Add-on system (Oct 2026 handover): pairs-well-with on product pages, one add-on card,
   spend-perk bar (off until approved), mixed-cart shipping choice and gift checkbox
   in the bag drawer and on the cart page. Data comes from snippets/eh-data.liquid. */
(function () {
  "use strict";
  if (!window.EH) return;
  var EH = window.EH;
  function money(c) { var d = c / 100; return "$" + (d % 1 === 0 ? d.toLocaleString("en-US") : d.toLocaleString("en-US", { minimumFractionDigits: 2 })); }
  function esc(t) { var d = document.createElement("div"); d.textContent = t == null ? "" : t; return d.innerHTML; }
  function prod(h) { return h && h !== "_" ? EH.products[h] : null; }
  function stockOf(p) { return p && p.v.some(function (v) { return v.q > 0; }); }
  /* Items that ship (the $1 Founding Reservation does not, so it gets no delivery label and never counts toward split shipping). */
  function ships(it) { return it.requires_shipping !== false; }
  function lineStock(it) { var d = it.properties && it.properties.Delivery; return d ? /^(In stock|READY TO SHIP)/.test(d) : EH.inStock(it.variant_id); }
  function handleOf(it) { var v = EH.byVariant[it.variant_id]; return v ? v.h : it.handle; }
  function post(url, body) { return fetch(url, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) }).then(function (r) { return r.json(); }); }
  var onCartPage = location.pathname.replace(/\/$/, "") === "/cart";
  function after() { if (onCartPage) location.reload(); else if (window.EverhartBag) window.EverhartBag.refresh(); }

  /* Bag suggestion, scored across every fine jewelry piece (Oct 2026). Rules come from stylist guidance:
     fill a missing category first, stack within a category only where it works (ring stack, ear stack,
     wrist stack, layered necklaces), keep the same metal, keep it smaller than the main piece,
     and never two statements together ("statement necklace or statement earrings, never both"). */
  var STATEMENT = { "riviere-half": 1, "statement-studs": 1 };
  var PENDANT = { "bezel-pendant": 1, "bezel-pendant-0-5ct-lab-diamond": 1 };
  var STUDS = { "bezel-studs": 1, "statement-studs": 1 };
  function tone(h) { return (EH.white || []).indexOf(h) > -1 ? "white" : "gold"; }
  function pickAddon(cart) {
    var have = {}, cats = {}, tones = { white: 0, gold: 0 }, maxP = 0, ring = null, statement = false, pendant = false, studs = false, pairs = {};
    cart.items.forEach(function (it) {
      var h = handleOf(it), p = prod(h); have[h] = true; if (!p) return;
      cats[p.ty] = true; tones[tone(h)]++; maxP = Math.max(maxP, p.price);
      if (p.ty === "Ring" && /^[\d.]+$/.test(it.variant_title || "")) ring = ring || it.variant_title;
      if (STATEMENT[h]) statement = true; if (PENDANT[h]) pendant = true; if (STUDS[h]) studs = true;
      var m = EH.pair[h]; if (m) { pairs[m.add] = 1; pairs[m.pw] = 1; }
    });
    var mainTone = tones.white > tones.gold ? "white" : tones.gold > tones.white ? "gold" : "";
    var allStock = cart.items.filter(ships).every(lineStock), scored = [];
    Object.keys(EH.products).forEach(function (h) {
      var p = prod(h); if (!p || !p.v || have[h]) return;
      var s = 0, line = "Complete the look";
      if (!cats[p.ty]) s += 3;
      else if (p.ty === "Ring") { s += 2; line = "Stack your rings"; }
      else if (p.ty === "Bracelet") { s += 2; line = "Make it a wrist stack"; }
      else if (p.ty === "Earrings") { line = "Make it an ear stack"; s += STUDS[h] && studs ? -2 : 2; }
      else if (p.ty === "Necklace") { line = "Layer it"; s += PENDANT[h] && pendant ? -3 : 1; }
      if (STATEMENT[h] && statement) s -= 5;
      if (mainTone) s += tone(h) === mainTone ? 2 : -2;
      if (maxP) { var r = p.price / maxP; s += r <= 0.6 ? 2 : r <= 1 ? 1 : r <= 1.5 ? -1 : -3; }
      if (pairs[h]) s += 1;
      if (allStock) s += stockOf(p) ? 1 : -1;
      if (p.v.length > 1 && !(p.ty === "Ring" && ring)) s -= 1; /* needs a size we don't know yet */
      scored.push({ s: s, h: h, p: p, line: line });
    });
    if (!scored.length) return null;
    /* near-ties (within 2 points) rotate by what's in the bag, so different bags see different pieces */
    scored.sort(function (x, y) { return y.s - x.s || x.p.price - y.p.price; });
    var top = scored.filter(function (x) { return x.s >= scored[0].s - 2; });
    var key = Object.keys(have).sort().join(","), hash = 0;
    for (var k = 0; k < key.length; k++) hash = (hash * 31 + key.charCodeAt(k)) >>> 0;
    var best = top[hash % top.length];
    best.size = best.p.ty === "Ring" ? ring : null;
    return best;
  }
  function addonHTML(a) {
    var p = a.p, multi = p.v.length > 1;
    var def = a.size ? p.v.filter(function (v) { return v.t === a.size; })[0] : null;
    if (!multi) def = p.v[0];
    var opts = "";
    if (multi) opts = '<div class="eh-addon-pick"><label class="cd-size"><span>' + esc(def ? "Size " + def.t : "Choose size") + '</span><select class="eh-addon-size" aria-label="Size">' +
      (def ? "" : '<option value="" selected disabled>Choose size</option>') +
      p.v.map(function (v) { return '<option value="' + v.id + '"' + (def && v.id === def.id ? " selected" : "") + ">" + esc(/^[\d.]+$/.test(v.t) ? "Size " + v.t : v.t) + "</option>"; }).join("") + "</select></label></div>";
    return '<button type="button" class="eh-addon-x" aria-label="No thanks">&times;</button><a class="eh-addon-img" href="' + p.url + '"><img src="' + p.img + '" alt="' + esc(p.t) + '"></a>' +
      '<div><p class="eh-addon-l">' + esc(a.line) + "</p>" +
      "<p class=\"eh-addon-t\"><a href=\"" + p.url + "\">" + esc(p.t) + "</a> <span>|</span> " + money(p.price) + "</p>" + opts +
      '<button type="button" class="btn eh-addon-btn" data-v="' + (def ? def.id : "") + '"' + (def ? "" : " disabled") + ">Add to bag</button></div>";
  }
  function perkHTML(total) {
    var P = EH.perks, t1 = P.t1, t2 = P.t2, pct = Math.min(100, total / t2 * 100), msg;
    if (total <= 0) msg = "Complimentary gift wrapping and a handwritten card on orders of " + money(t1) + ".";
    else if (total < t1) {
      msg = "You're " + money(t1 - total) + " away from complimentary gift wrapping and a handwritten card.";
      var n = prod(P.nudge); if (n && t1 - total <= n.price) msg += " The " + n.t + " (" + money(n.price) + ") would complete it.";
    } else if (total < t2) msg = "Your order will be wrapped by hand with a handwritten card. You're " + money(t2 - total) + " away from Priority Express delivery and a reserved Celestial Founding place.";
    else msg = "You've unlocked everything: wrapped by hand, a handwritten card, Priority Express delivery on pieces in stock, and a reserved Celestial Founding place.";
    return '<p>' + esc(msg) + '</p><div class="eh-bar"><span style="width:' + pct + '%"></span><i style="left:' + (t1 / t2 * 100) + '%"></i></div>';
  }
  /* Mixed bag: ready-to-ship pieces go out first and made-to-order pieces follow when they're made, at no extra cost (the Mejuri approach). */
  function splitHTML() {
    var r = EH.etaFor(true), m = EH.etaFor(false);
    return '<p class="eh-split-h">Your order arrives in two deliveries, at no extra cost.</p>' +
      '<p class="eh-split-n"><span class="d is-stock"></span>Ready-to-ship pieces arrive ' + esc(r.short) + '.</p>' +
      '<p class="eh-split-n"><span class="d"></span>Made-to-order pieces arrive ' + esc(m.short) + (m.note ? ' (' + esc(m.note) + ')' : '') + '.</p>';
  }

  function fill(cart, ids) {
    var perk = document.getElementById(ids.perk), addon = document.getElementById(ids.addon), split = document.getElementById(ids.split), gift = document.getElementById(ids.gift);
    var attrs = cart.attributes || {};
    if (perk) { perk.hidden = !EH.perks.on; if (EH.perks.on) perk.innerHTML = perkHTML(cart.total_price); }
    var off = false; try { off = sessionStorage.getItem("ehAddonOff") === "1"; } catch (x) {}
    if (addon && EH.freezeAddon !== addon) { var a = cart.item_count && !EH.hideAddon && !off ? pickAddon(cart) : null; addon.hidden = !a; if (a) addon.innerHTML = addonHTML(a); }
    var shipItems = cart.items.filter(ships), mixed = shipItems.some(lineStock) && shipItems.some(function (it) { return !lineStock(it); });
    if (split) {
      split.hidden = !mixed;
      if (mixed) {
        split.innerHTML = splitHTML();
        if (attrs["Shipping preference"] !== "Ship what's ready now") post("/cart/update.js", { attributes: { "Shipping preference": "Ship what's ready now" } });
      } else if (attrs["Shipping preference"]) post("/cart/update.js", { attributes: { "Shipping preference": "" } });
    }
    if (gift) gift.checked = attrs["Gift: hide prices"] === "Yes";
  }

  document.addEventListener("change", function (e) {
    if (e.target.id === "cd-gift" || e.target.id === "cp-gift") post("/cart/update.js", { attributes: { "Gift: hide prices": e.target.checked ? "Yes" : "" } });
    if (e.target.classList.contains("eh-addon-size")) { var b = e.target.closest(".eh-addon").querySelector(".eh-addon-btn"); if (b) { b.dataset.v = e.target.value; b.disabled = !e.target.value; } }
    var pk = e.target.closest(".cd-size"); if (pk && window.EHSize) pk.querySelector("span").textContent = window.EHSize.short(e.target.options[e.target.selectedIndex].text.replace(/^Size /, ""));
  });
  /* fade the card out, then fold its space away so the bag doesn't jump */
  function fadeAway(card) {
    EH.freezeAddon = card;
    card.style.maxHeight = card.scrollHeight + "px";
    void card.offsetHeight;
    card.classList.add("is-fading");
    setTimeout(function () { card.hidden = true; card.classList.remove("is-fading"); card.style.maxHeight = ""; EH.freezeAddon = null; }, 650);
  }
  document.addEventListener("click", function (e) {
    var x = e.target.closest(".eh-addon-x");
    if (x) { try { sessionStorage.setItem("ehAddonOff", "1"); } catch (err) {} fadeAway(x.closest(".eh-addon")); return; }
    var b = e.target.closest(".eh-addon-btn, .eh-pair-btn"); if (!b) return;
    var id = Number(b.dataset.v); b.disabled = true; b.textContent = "Adding...";
    post("/cart/add.js", { id: id, quantity: 1, properties: { Delivery: EH.shipLine(id) } })
      .then(function () {
        b.textContent = "Added";
        var card = b.classList.contains("eh-addon-btn") && !onCartPage ? b.closest(".eh-addon") : null;
        if (card) {
          /* keep the card on screen saying "Added", then fade it out; the next suggestion waits until the bag is opened again */
          EH.hideAddon = true; EH.freezeAddon = card;
          setTimeout(function () { fadeAway(card); }, 900);
        }
        if (b.classList.contains("eh-pair-btn") && window.EverhartBag) window.EverhartBag.open(); else after();
      })
      .catch(function () { b.disabled = false; b.textContent = "Try again"; });
  });

  window.EHCart = { drawer: function (cart) { fill(cart, { perk: "cd-perk", addon: "cd-addon", split: "cd-split", gift: "cd-gift" }); } };
  if (document.getElementById("cp-extras")) fetch("/cart.js").then(function (r) { return r.json(); }).then(function (c) { fill(c, { perk: "cp-perk", addon: "cp-addon", split: "cp-split", gift: "cp-gift" }); });

  // Pairs well with (product page): one piece from the pairing map.
  var box = document.getElementById("eh-pair");
  if (box) {
    var m = EH.pair[box.dataset.handle], p = m && prod(m.pw);
    if (p) {
      var multi = p.v.length > 1;
      box.innerHTML = '<p class="eyebrow">Pairs well with' + (m.pwLabel ? " &middot; " + esc(m.pwLabel) : "") + "</p>" +
        '<a class="eh-pair-card" href="' + p.url + '"><img src="' + p.img + '" alt=""><span><strong>' + esc(p.t) + "</strong>" + money(p.price) + "<small>" + (p.v.some(function (v) { return v.q > 0; }) ? EH.msg.stock : EH.msg.mto) + "</small></span></a>" +
        (multi ? '<a class="btn btn-outline eh-pair-view" href="' + p.url + '">Choose a size</a>' : '<button type="button" class="btn btn-outline eh-pair-btn" data-v="' + p.v[0].id + '">Add to bag</button>');
      box.hidden = false;
    }
  }
})();

/* Email typo guard (Oct 2026), the Mailcheck pattern (Kicksend): before a sign-up form submits, catch
   common domain typos like gmail.cm or yaho.com and ask "Did you mean ...?". Runs first (capture) so
   Shopify's spam check and our tagging only run once the address looks right. */
(function () {
  "use strict";
  var DOMAINS = ["gmail.com", "yahoo.com", "hotmail.com", "outlook.com", "icloud.com", "aol.com", "live.com", "msn.com", "me.com", "mac.com", "comcast.net", "att.net", "verizon.net", "sbcglobal.net", "protonmail.com", "proton.me", "ymail.com", "googlemail.com", "bellsouth.net", "cox.net", "charter.net", "hotmail.co.uk", "yahoo.co.uk", "rocketmail.com", "frontier.com", "windstream.net", "earthlink.net", "optonline.net", "roadrunner.com", "juno.com", "mail.com", "gmx.com", "aim.com", "twc.com", "centurylink.net", "embarqmail.com", "frontiernet.net", "optimum.net", "mindspring.com", "netzero.net", "zoho.com", "fastmail.com"];
  /* Real addresses that look like typos of a big domain (myyahoo.com is not yahoo.com misspelled). The guard checks these first and never suggests a change for them. */
  var KEEP = ["myyahoo.com", "rocketmail.com", "ymail.com", "yahoo.com.ph", "gmx.de", "gmx.net", "email.com"];
  var KEEP_RE = /^(yahoo|hotmail|outlook)\.(com?\.)?(uk|ca|au|nz|ie|in|sg|ph|my|hk|tw|jp|kr|id|th|vn|br|mx|ar|cl|pe|za|fr|de|it|es|pt|nl|be|dk|se|no|fi|gr|at|ch|pl|cz|ro|tr|sa|ae)$/;
  var TLDS = { con: "com", cmo: "com", comm: "com", ocm: "com", vom: "com", xom: "com", cm: "com", om: "com", co: "com", cpm: "com", coom: "com", nte: "net", ner: "net", nett: "net", ogr: "org", rog: "org" };
  function dist(a, b) {
    var m = [], i, j;
    for (i = 0; i <= a.length; i++) m[i] = [i];
    for (j = 0; j <= b.length; j++) m[0][j] = j;
    for (i = 1; i <= a.length; i++) for (j = 1; j <= b.length; j++)
      m[i][j] = Math.min(m[i - 1][j] + 1, m[i][j - 1] + 1, m[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
    return m[a.length][b.length];
  }
  function suggest(email) {
    var at = email.lastIndexOf("@"); if (at < 1) return null;
    var user = email.slice(0, at), dom = email.slice(at + 1).toLowerCase();
    if (KEEP.indexOf(dom) > -1 || KEEP_RE.test(dom)) return null;
    if (DOMAINS.indexOf(dom) > -1) return null;
    var best = null, bd = 99;
    DOMAINS.forEach(function (d) { var k = dist(dom, d); if (k < bd) { bd = k; best = d; } });
    if (best && bd <= 2) return user + "@" + best;
    var dot = dom.lastIndexOf("."); if (dot < 1) return null;
    var tld = dom.slice(dot + 1);
    if (TLDS[tld] && dom.slice(0, dot).indexOf(".") === -1 && tld !== "co") return user + "@" + dom.slice(0, dot) + "." + TLDS[tld];
    return null;
  }
  window.ehSuggest = suggest;
  var FORMS = "#wl-form, #footer-news, #pop-form";
  document.addEventListener("submit", function (e) {
    var f = e.target; if (!f.matches || !f.matches(FORMS)) return;
    var input = f.querySelector('input[type="email"]'); if (!input) return;
    var val = (input.value || "").trim();
    if (f.dataset.emailOk === val) return;
    var s = suggest(val); if (!s) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var box = f.querySelector(".email-hint");
    if (!box) { box = document.createElement("p"); box.className = "email-hint"; box.setAttribute("role", "alert"); (input.closest(".wl-row, .news-row, .xc-wl") || input).insertAdjacentElement("afterend", box); }
    box.innerHTML = 'Did you mean <strong></strong>? <button type="button" data-fix>Yes, fix it</button> <button type="button" data-keep>No, keep it</button>';
    box.querySelector("strong").textContent = s;
    box.querySelector("[data-fix]").onclick = function () { input.value = s; f.dataset.emailOk = s; box.remove(); f.requestSubmit ? f.requestSubmit() : f.submit(); };
    box.querySelector("[data-keep]").onclick = function () { f.dataset.emailOk = val; box.remove(); f.requestSubmit ? f.requestSubmit() : f.submit(); };
  }, true);
})();

/* Show the address back after sign-up (Nov 2026). Most bounces are typos before the @, which the typo guard can't see.
   Waitlist pattern: "You're on the list" plus where we'll write to, with a small way to fix it. */
(function () {
  "use strict";
  var FORMS = "#wl-form, #footer-news, #pop-form";
  var KEY = "eh-signup-email", FIX = "eh-signup-fix";
  function get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return JSON.parse(get(k) || "null"); } catch (e) { return null; } }
  if (!document.getElementById("eh-sent-css")) {
    var css = document.createElement("style"); css.id = "eh-sent-css";
    css.textContent = ".eh-fixline{margin:6px 0 0;font-size:.78rem;opacity:.75}.eh-fix{background:none;border:0;padding:0;font:inherit;color:inherit;text-decoration:underline;text-underline-offset:3px;cursor:pointer}.eh-addr{font-weight:600;word-break:break-all}";
    document.head.appendChild(css);
  }
  document.addEventListener("submit", function (e) {
    var f = e.target; if (!f.matches || !f.matches(FORMS)) return;
    var input = f.querySelector('input[type="email"]'); if (!input || !input.value) return;
    set(KEY, JSON.stringify({ email: input.value.trim(), form: f.id }));
  });
  var OK = '.eh-done[data-state="ok"], .wl-done, .xc-done[data-state="ok"]';
  function addLine(el) {
    if (el.dataset.ehSent) return; el.dataset.ehSent = "1";
    var saved = read(KEY); if (!saved || !saved.email) return;
    var f = el.closest("form") || document.getElementById(saved.form);
    var target = el.classList.contains("wl-done") ? el.querySelector("p") : el;
    if (!target) return;
    var msg = document.createElement("span");
    msg.innerHTML = 'You&rsquo;re on the list. We&rsquo;ll contact you at <span class="eh-addr"></span>.';
    msg.querySelector(".eh-addr").textContent = saved.email;
    if (target === el) { el.textContent = ""; el.appendChild(msg); }
    else { var p = document.createElement("p"); p.className = "eh-sentline"; p.innerHTML = 'We&rsquo;ll contact you at <span class="eh-addr"></span>.'; p.querySelector(".eh-addr").textContent = saved.email; target.insertAdjacentElement("afterend", p); target = p; }
    var fix = document.createElement("p"); fix.className = "eh-fixline";
    fix.innerHTML = 'Not right? <button type="button" class="eh-fix">Fix it</button>';
    fix.querySelector(".eh-fix").onclick = function () { reopen(f, saved, el, fix); };
    target.insertAdjacentElement("afterend", fix);
  }
  function reopen(f, saved, done, fix) {
    var input = f && f.querySelector('input[type="email"]');
    if (input) {
      if (!done.classList.contains("wl-done")) done.remove(); fix.remove();
      for (var n = input; n && n !== f; n = n.parentElement) { if (n.hidden) n.hidden = false; if (getComputedStyle(n).display === "none") n.style.display = ""; }
      input.value = saved.email; input.focus(); input.select(); return;
    }
    set(FIX, JSON.stringify(saved));
    var u = new URL(location.href); u.searchParams.delete("customer_posted"); u.searchParams.delete("contact_posted"); u.hash = saved.form || "";
    if (u.pathname + u.search === location.pathname + location.search) { history.replaceState(null, "", u.toString()); location.reload(); }
    else location.href = u.toString();
  }
  function fillAfterReload() {
    var saved = read(FIX); if (!saved) return; set(FIX, null);
    var f = document.getElementById(saved.form); if (!f) return;
    if (saved.form === "pop-form") { var pop = document.getElementById("signup-pop"); if (pop) { pop.hidden = false; requestAnimationFrame(function () { pop.classList.add("is-in"); }); } }
    var input = f.querySelector('input[type="email"]'); if (!input) return;
    input.value = saved.email;
    try { f.scrollIntoView({ block: "center" }); } catch (e) {}
    input.focus(); input.select();
  }
  function scan(root) { Array.prototype.forEach.call((root || document).querySelectorAll(OK), addLine); }
  function init() {
    fillAfterReload(); scan();
    if (window.MutationObserver) new MutationObserver(function (ms) {
      ms.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, function (n) { if (n.nodeType !== 1) return; if (n.matches(OK)) addLine(n); scan(n); }); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
